module.exports = __webpack_public_path__ + "img/frame.8fc85ac0.jpg";